<template>
    <div>
     <div class="upload-container">
         <div class="common upload-top">
            <img src="../../../images/submit.png" class="img-submit">
            <p>提交成功，等待馆员审核入藏</p>
            <div class="number">
                {{subtitle}}
            </div>
         </div>
     </div>
 
     <div class="upload-btn">
         <div class="check-btnA" @click="closePage">
             关闭
         </div>
         <div class="check-btnB" @click="nextUpload">
                再发一条
        </div>
     </div>
     <div class="naviPosition" />
     <div class="digNavigate">
       <router-link class="navItm" :to="{ name: 'Waphome' }">
         <img src="../../../images/home.png" class="img-normal">
         <img src="../../../images/home_select.png" class="img-active">
         <label>首页</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Waplist' }">
         <img src="../../../images/res.png" class="img-normal">
         <img src="../../../images/res_select.png" class="img-active">
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
       </router-link>
       <router-link class="navItm active" :to="{ name: 'Wapcertified' }">
         <img src="../../../images/upload.jpg" class="img-normal">
         <img src="../../../images/upload_select.jpg" class="img-active">
         <label>上传</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Wapuser' }">
         <img src="../../../images/use.png" class="img-normal">
         <img src="../../../images/use_select.png" class="img-active">
         <label>我的</label>
       </router-link>
     </div>
    </div>
 </template>
 <script>
 import {
  collectiongetById
} from '@/api/library'
 import api from "../../../api/home.js";
 export default {
     data(){
         return{
             subtitle: '馆藏编号CQU96189161651',
             clients:{}
         }
     },
    mounted() {
        this.collectiongetById()
    },
    created(){
        this.requestclient();
    },
     methods:{
                //获取应用信息
      requestclient() {
        const that = this;
        api
          .requestclient({ tenantId: this.$store.getters.tenantId })
          .then(r => {
            that.clients = r.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
        async collectiongetById() {
            const res = await collectiongetById({
                ids: this.$route.query.collectionId
            })
            if (res.data) {
                this.subtitle = '馆藏编号' + res.data[0].collectionId
            }
            },
        closePage() {
            console.log('rerererw')
           this.$router.push('/wap')
           
        },
        nextUpload() {
             this.$router.push('/wap/upload')
        }
         },
    
 }
 </script>
 <style src="@/styles/wap.scss" lang="scss" scoped></style>
 <style scoped>
     .upload-container {
         box-sizing: border-box;
         width: 100%;
         /* padding-left: 0.3333rem;
         padding-right: 0.3333rem;
         padding-top: 0.3704rem; */
         padding: 0.3704rem 0.3333rem 0.3241rem 0.3333rem;
         background: #eee;
     }
     .common {
         width: 100%;
         background: #FFFFFF;
         box-shadow: 0px 0.0463rem 0.1389rem 0px rgba(0,0,0,0.05);
         border-radius: 0.1111rem;
     }
     .upload-top {
         box-sizing: border-box;
         height: 7.7778rem;
         margin-bottom: 0.2778rem;
         padding-left: 0.3704rem;
         padding-top: 0.3704rem;
         padding-right: 0.3704rem;
     }
     
     .img-submit {
        height: 1.4444rem;
        margin-top: 1.8148rem;
        margin-left: 3.9444rem;
     }
     .upload-top p {
        width: 100%;
        height: 1.0926rem;
        font-size: 0.5rem;
        font-weight: 700;
        color: #4C70E8;
        text-align: center;
        line-height: 1.0926rem;
     }
    .number {
        width: 100%;
        height: 0.5rem;
        background: #F3F4F9;
        margin: 0 auto;
        border-radius: 0.25rem;
        text-align: center;
        line-height: 0.5rem;
        font-size: 0.1667rem;
        font-weight: 400;
        color: #1F233E;
        opacity: 0.5;
    }
     .upload-btn {
         width: 100%;
         height: 2.8704rem;
         position: absolute;
         bottom:1.35rem;;
         box-sizing: border-box;
         padding: 0.3704rem 0.3333rem 0.3704rem 0.3333rem;
         background: #FFFFFF;
         font-size: 0.3333rem;
         font-weight: 700;
         color: #FFFFFF;
     }
     .check-btnA {
         width: 100%;
         height: 0.9259rem;
         background: #7B84A1;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
         margin-bottom: 0.2778rem;
     }
     .check-btnB {
         width: 100%;
         height: 0.9259rem;
         background: #4C70E8;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
     }
     .digNavigate {
        border-top:  1px solid #F3F4F9;
     }
 </style>